import { render, staticRenderFns } from "./BranchTip.vue?vue&type=template&id=70f075d9"
import script from "./BranchTip.vue?vue&type=script&lang=js"
export * from "./BranchTip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports